export const reArrangeMenuModalTranslationJP = {
  ReArrangeMenuModal: {
    head_title: 'メニュー再配置',
    save: '保存',
    target_menu: '対象メニュー',
    re_arrange_menu: '再配置後メニュー',
    menu: 'メニュー',
    menu_code: 'メニューコード',
    menu_name: 'メニュー名',
    menu_type: 'メニュー種別',
    pos_info: 'レジ情報',
    move: '移動',
    return: '戻す',
    selection: '選択',
    pos_cd: 'POSコード',
    pos_name: 'POS名',
    pos_type: 'POS種別',
    price_not_include_tax: '金額<br/>(税抜き)',
    price_include_tax: '金額<br/>(税込み)<br/>※レジデータ取<br/>込から取得',
    sub_menu: 'サブ',
    main_menu: '通常',
    guide_text: '対象メニューから、移動するレジ情報を選択し移動してください。',
    warning_menu_name_required: 'メニュー名は必須です',
  },
};
